import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Welcome.css';

const Welcome = () => {
  const navigate = useNavigate();

  const handleCheckin = () => {
    navigate('/checkin');
  };

  const handleCheckout = () => {
    navigate('/checkout');
  };

  return (
    <div className="welcome-container">
      <div className="welcome-card">
        <h2>O que você deseja fazer?</h2>
        <div className="button-container">
          <button className="action-button checkin-button" onClick={handleCheckin}>
            Check-in
          </button>
          <button className="action-button checkout-button" onClick={handleCheckout}>
            Check-out
          </button>
        </div>
        <div className="welcome-content">
          <div className="feature-highlight">
            <p className="navigation-hint">
              Ou utilize o menu superior para acessar outras seções do sistema.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Welcome;